import flow from 'lodash/fp/flow';
import getOr from 'lodash/fp/getOr';
import filter from 'lodash/fp/filter';

export default function getCartState({ booking, productId }) {
	const hasDifferentProductId = product => product?.productId !== productId;
	const hotelProducts = flow(getOr([], 'hotelProducts'), filter(hasDifferentProductId))(booking);
	const eventProducts = flow(getOr([], 'eventProducts'), filter(hasDifferentProductId))(booking);

	if (eventProducts.length >= 1 && hotelProducts.length >= 1) {
		return 'stay and ancillary product';
	}
	if (eventProducts.length >= 1) {
		return 'ancillary product only';
	}
	if (hotelProducts.length >= 1) {
		return 'stay only';
	}
	return 'empty';
}
